export default {
    getPlatformApprovalData(state) {
        return state.approvalData;
    },
};
